// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableBody, DataTableHead, VisuallyHidden } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { tableProps } from "@store/Themes/common/props/table";
import { useFastenersTableApiParameter } from "@store/Framework/Store/Store/Components/FastenersTable/FastenersTableHooks";
import updateSearchFields from "@store/Framework/Store/Store/Components/FastenersTable/Handlers/UpdateSearchFields";
import ProductFastenersDataTableRow from "@store/Library/Components/ProductFasteners/ProductFastenersDataTableRow";
import React from "react";

type SortOrderOptions = "ascending" | "descending" | false;

export interface ProductFastenersDataTableProps {
    product: ProductModel;
    products: ProductModel[];
    tableId: string;
    showLength: boolean;
    showHeadDiameter: boolean;
    showThread: boolean;
    showPoint: boolean;
    showHead: boolean;
    showFinish: boolean;
}

export interface ProductFastenersDataTableStyles {
    wrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    itemHeader?: DataTableHeaderProps;
    lengthHeader?: DataTableHeaderProps;
    headDiameterHeader?: DataTableHeaderProps;
    threadHeader?: DataTableHeaderProps;
    pointHeader?: DataTableHeaderProps;
    headHeader?: DataTableHeaderProps;
    finishHeader?: DataTableHeaderProps;
    actionsHeader?: DataTableHeaderProps;
}

export const productFastenersDataTableStyles: ProductFastenersDataTableStyles = {
    tableWrapper: tableProps.wrapper,
    dataTable: tableProps.dataTable,
    itemHeader: tableProps.tightHeader,
    lengthHeader: tableProps.tightHeader,
    headDiameterHeader: tableProps.tightHeader,
    threadHeader: tableProps.tightHeader,
    pointHeader: tableProps.tightHeader,
    headHeader: tableProps.tightHeader,
    finishHeader: tableProps.tightHeader,
    actionsHeader: tableProps.tightHeader,
};

const styles = productFastenersDataTableStyles;

const ProductFastenersDataTable = ({
    product,
    products,
    tableId,
    showLength,
    showHeadDiameter,
    showThread,
    showPoint,
    showHead,
    showFinish,
}: ProductFastenersDataTableProps) => {
    const dispatch = useAppDispatch();
    const fastenersTableApiParameter = useFastenersTableApiParameter();

    const headerClick = (sortField: string) => {
        let sortOrder: "asc" | "desc" = "asc";

        if (fastenersTableApiParameter.sortBy === sortField) {
            sortOrder = fastenersTableApiParameter.sortOrder === "asc" ? "desc" : "asc";
        }

        dispatch(
            updateSearchFields({
                productId: product.id,
                sortBy: sortField,
                sortOrder,
            }),
        );
    };

    const sorted = (sortField: string): SortOrderOptions => {
        if (fastenersTableApiParameter.sortBy !== sortField) {
            return false;
        }

        return fastenersTableApiParameter.sortOrder === "desc" ? "descending" : "ascending";
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.tableWrapper}>
                <DataTable {...styles.dataTable}>
                    <DataTableHead>
                        <DataTableHeader {...styles.itemHeader}>{translate("Item Code")}</DataTableHeader>
                        {showLength && (
                            <DataTableHeader
                                sorted={sorted("length")}
                                onSortClick={() => headerClick("length")}
                                {...styles.lengthHeader}
                            >
                                {translate("Length")}
                            </DataTableHeader>
                        )}
                        {showHeadDiameter && (
                            <DataTableHeader
                                sorted={sorted("headDiameter")}
                                onSortClick={() => headerClick("headDiameter")}
                                {...styles.headDiameterHeader}
                            >
                                {translate("Diam.")}
                            </DataTableHeader>
                        )}
                        {showThread && (
                            <DataTableHeader
                                sorted={sorted("thread")}
                                onSortClick={() => headerClick("thread")}
                                {...styles.threadHeader}
                            >
                                {translate("Thread")}
                            </DataTableHeader>
                        )}
                        {showPoint && (
                            <DataTableHeader
                                sorted={sorted("point")}
                                onSortClick={() => headerClick("point")}
                                {...styles.pointHeader}
                            >
                                {translate("Point")}
                            </DataTableHeader>
                        )}
                        {showHead && (
                            <DataTableHeader
                                sorted={sorted("head")}
                                onSortClick={() => headerClick("head")}
                                {...styles.headHeader}
                            >
                                {translate("Head")}
                            </DataTableHeader>
                        )}
                        {showFinish && (
                            <DataTableHeader
                                sorted={sorted("finish")}
                                onSortClick={() => headerClick("finish")}
                                {...styles.finishHeader}
                            >
                                {translate("Finish")}
                            </DataTableHeader>
                        )}
                        <DataTableHeader {...styles.actionsHeader}>
                            <VisuallyHidden>{translate("Actions")}</VisuallyHidden>
                        </DataTableHeader>
                    </DataTableHead>
                    <DataTableBody>
                        {products?.map(product => (
                            <ProductFastenersDataTableRow
                                key={product.id}
                                product={product}
                                tableId={tableId}
                                showLength={showLength}
                                showHeadDiameter={showHeadDiameter}
                                showThread={showThread}
                                showPoint={showPoint}
                                showHead={showHead}
                                showFinish={showFinish}
                            />
                        ))}
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default ProductFastenersDataTable;
